export default __webpack_public_path__ + "static/media/location.f585430c.svg";